import script from "./LanguageManager.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageManager.vue?vue&type=script&setup=true&lang=js"

import "./LanguageManager.vue?vue&type=style&index=0&id=5bb81df4&lang=css"

const __exports__ = script;

export default __exports__